var _rect, _g, _g2, _rect2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPolkajsWallet = function SvgPolkajsWallet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 196,
    height: 196,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 187.803,
    height: 187.803,
    x: 4.197,
    y: 4.197,
    fill: "url(#polkajs-wallet_svg__a)",
    rx: 38.819
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#polkajs-wallet_svg__b)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#polkajs-wallet_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#polkajs-wallet_svg__d)",
    fillOpacity: 0.19,
    d: "M98.374 43.017c-23.002.092-41.625 18.716-41.718 41.717 0 4.607.744 9.182 2.2 13.551a5.966 5.966 0 0 0 7.339 3.656 5.938 5.938 0 0 0 3.546-7.312 27.526 27.526 0 0 1-1.624-10.634c.502-16.613 14.374-29.675 30.987-29.174 16.613.502 29.675 14.374 29.174 30.987-.471 15.553-12.719 28.184-28.255 29.13 0 0-5.855.356-8.768.713a30.39 30.39 0 0 0-3.19.633.383.383 0 0 1-.545.004l-.005-.004a.382.382 0 0 1 0-.466l.907-4.945 5.5-24.735a5.719 5.719 0 1 0-11.185-2.394s-13.08 60.544-13.08 61.094a5.497 5.497 0 0 0 4.07 6.705h.303a5.494 5.494 0 0 0 6.732-4.096 1.415 1.415 0 0 1 0-.273c.163-.713 1.813-8.769 1.813-8.769a14.84 14.84 0 0 1 12.283-11.681c1.263-.193 6.569-.55 6.569-.55 22.913-2.283 39.636-22.71 37.348-45.624-2.085-20.898-19.398-36.987-40.401-37.533Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.38,
    d: "M98.374 43.017c-23.002.092-41.625 18.716-41.718 41.717 0 4.607.744 9.182 2.2 13.551a5.966 5.966 0 0 0 7.339 3.656 5.938 5.938 0 0 0 3.546-7.312 27.526 27.526 0 0 1-1.624-10.634c.502-16.613 14.374-29.675 30.987-29.174 16.613.502 29.675 14.374 29.174 30.987-.471 15.553-12.719 28.184-28.255 29.13 0 0-5.855.356-8.768.713a30.39 30.39 0 0 0-3.19.633.383.383 0 0 1-.545.004l-.005-.004a.382.382 0 0 1 0-.466l.907-4.945 5.5-24.735a5.719 5.719 0 1 0-11.185-2.394s-13.08 60.544-13.08 61.094a5.497 5.497 0 0 0 4.07 6.705h.303a5.494 5.494 0 0 0 6.732-4.096 1.415 1.415 0 0 1 0-.273c.163-.713 1.813-8.769 1.813-8.769a14.84 14.84 0 0 1 12.283-11.681c1.263-.193 6.569-.55 6.569-.55 22.913-2.283 39.636-22.71 37.348-45.624-2.085-20.898-19.398-36.987-40.401-37.533Z"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#polkajs-wallet_svg__e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#polkajs-wallet_svg__f)",
    fillRule: "evenodd",
    d: "m100.023 114.938.039.628h-.004l-.252.016-.702.045c-.593.039-1.415.095-2.327.161-1.825.134-4 .311-5.439.487-1.005.144-2.002.34-2.987.586a1.015 1.015 0 0 1-1.27-.121l-.006-.006-.005-.005-.028-.028-.025-.032a1.012 1.012 0 0 1-.1-1.078l.888-4.844 5.5-24.74.001-.003a5.09 5.09 0 0 0-9.953-2.128v.001l-.616-.133a5.718 5.718 0 1 1 11.184 2.394l-5.5 24.735-.906 4.945a.382.382 0 0 0 0 .466l.005.004c.154.15.396.15.545-.004a30.39 30.39 0 0 1 3.19-.633c2.913-.357 8.768-.713 8.768-.713Zm-17.448 23.467s-1.65 8.056-1.813 8.769c-.009.088-.009.18 0 .273a5.494 5.494 0 0 1-6.731 4.096h-.304a5.497 5.497 0 0 1-4.07-6.705c0-.55 13.08-61.094 13.08-61.094l.616.133-.562 2.603a34142.073 34142.073 0 0 0-5.978 27.737c-1.635 7.602-3.27 15.221-4.496 20.974-.613 2.877-1.124 5.286-1.482 6.993a299.4 299.4 0 0 0-.522 2.547l-.026.142v.043l-.02.077a4.868 4.868 0 0 0 3.518 5.918l.01.002h.316l.077.02a4.864 4.864 0 0 0 5.929-3.494l.002-.008.009-.032a2.008 2.008 0 0 1 .007-.288l.004-.039.01-.038c.079-.348.53-2.529.964-4.638l.585-2.847.26-1.268v-.001a15.47 15.47 0 0 1 12.805-12.178c.66-.101 2.332-.24 3.805-.353.744-.057 1.448-.107 1.966-.144l.619-.043.222-.015c22.562-2.254 39.027-22.37 36.774-44.934l.626-.063c2.288 22.914-14.435 43.341-37.348 45.624 0 0-5.306.357-6.569.55a14.84 14.84 0 0 0-12.284 11.681Zm56.2-57.855-.626.063c-2.054-20.58-19.1-36.425-39.782-36.966-22.651.096-40.99 18.437-41.081 41.089 0 4.535.731 9.04 2.164 13.341a5.337 5.337 0 0 0 6.54 3.268 5.308 5.308 0 0 0 3.154-6.515 28.157 28.157 0 0 1-1.656-10.858c.515-16.959 14.676-30.292 31.635-29.78 16.96.512 30.296 14.674 29.784 31.635-.48 15.878-12.985 28.773-28.845 29.739l-.039-.628c15.536-.946 27.784-13.577 28.255-29.13.501-16.613-12.561-30.485-29.174-30.987-16.613-.501-30.485 12.561-30.987 29.174a27.526 27.526 0 0 0 1.624 10.634 5.938 5.938 0 0 1-3.546 7.312 5.966 5.966 0 0 1-7.339-3.656 42.852 42.852 0 0 1-2.2-13.55c.093-23.002 18.716-41.626 41.718-41.718 21.003.545 38.316 16.635 40.401 37.533Z",
    clipRule: "evenodd",
    style: {
      mixBlendMode: "overlay"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#polkajs-wallet_svg__g)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#polkajs-wallet_svg__h)",
    fillOpacity: 0.19,
    d: "M100.904 139.206a6.953 6.953 0 0 0-8.223 5.39c-.01.035-.013.07-.022.105a6.924 6.924 0 0 0 5.306 8.245h.193a6.811 6.811 0 0 0 8.223-5.024c.009-.026.013-.057.022-.084v-.382a7.21 7.21 0 0 0-5.499-8.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.38,
    d: "M100.904 139.206a6.953 6.953 0 0 0-8.223 5.39c-.01.035-.013.07-.022.105a6.924 6.924 0 0 0 5.306 8.245h.193a6.811 6.811 0 0 0 8.223-5.024c.009-.026.013-.057.022-.084v-.382a7.21 7.21 0 0 0-5.499-8.25Z"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#polkajs-wallet_svg__i)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#polkajs-wallet_svg__j)",
    fillRule: "evenodd",
    d: "M92.68 144.596a.763.763 0 0 0-.01.053l-.011.052a6.924 6.924 0 0 0 5.306 8.245h.193a6.811 6.811 0 0 0 8.223-5.024c.005-.013.008-.028.011-.042l.011-.042v-.382a7.21 7.21 0 0 0-5.499-8.25 6.953 6.953 0 0 0-8.223 5.39Zm13.094 3.16-.005.019a6.182 6.182 0 0 1-7.463 4.559l-.073-.017h-.193a6.295 6.295 0 0 1-4.768-7.475c.008-.031.013-.06.016-.074v-.003l.004-.018.002-.011.003-.012a6.323 6.323 0 0 1 7.472-4.903 6.58 6.58 0 0 1 5.014 7.528l-.009.053v.354Z",
    clipRule: "evenodd",
    style: {
      mixBlendMode: "overlay"
    }
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 187.803,
    height: 187.803,
    x: 4.197,
    y: 4.197,
    stroke: "url(#polkajs-wallet_svg__k)",
    strokeOpacity: 0.15,
    strokeWidth: 1.049,
    rx: 38.819
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "polkajs-wallet_svg__a",
    x1: 98.099,
    x2: 98.099,
    y1: 4.197,
    y2: 192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B1B1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D0D0D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "polkajs-wallet_svg__d",
    x1: 97.82,
    x2: 97.82,
    y1: 43.017,
    y2: 151.719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F6F6F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "polkajs-wallet_svg__f",
    x1: 135.075,
    x2: 35.408,
    y1: 44.231,
    y2: 119.717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "polkajs-wallet_svg__h",
    x1: 99.503,
    x2: 99.503,
    y1: 139.059,
    y2: 153.138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F6F6F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "polkajs-wallet_svg__j",
    x1: 105.843,
    x2: 92.432,
    y1: 139.216,
    y2: 152.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "polkajs-wallet_svg__k",
    x1: 183.082,
    x2: 4.197,
    y1: 6.296,
    y2: 185.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "polkajs-wallet_svg__b",
    width: 134.789,
    height: 162.582,
    x: 30.427,
    y: 20.984,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.197
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 13.115
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.65 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1325_78243"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1325_78243",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "polkajs-wallet_svg__c",
    width: 83.378,
    height: 111.85,
    x: 55.607,
    y: 41.968,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.098
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.049
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.36 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    mode: "overlay",
    result: "effect1_innerShadow_1325_78243"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1.049,
    dy: -1.049
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.049
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.46 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_innerShadow_1325_78243",
    mode: "overlay",
    result: "effect2_innerShadow_1325_78243"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "polkajs-wallet_svg__e",
    width: 83.378,
    height: 111.85,
    x: 55.607,
    y: 41.968,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.098
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.049
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.36 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    mode: "overlay",
    result: "effect1_innerShadow_1325_78243"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1.049,
    dy: -1.049
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.049
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.46 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_innerShadow_1325_78243",
    mode: "overlay",
    result: "effect2_innerShadow_1325_78243"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "polkajs-wallet_svg__g",
    width: 14.009,
    height: 15.129,
    x: 92.499,
    y: 139.059,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.098
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.525
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.36 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_1325_78243"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "polkajs-wallet_svg__i",
    width: 14.009,
    height: 15.129,
    x: 92.499,
    y: 139.059,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.098
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.525
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.36 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_1325_78243"
  })))));
};
export default SvgPolkajsWallet;